import { TireOfferPaymentSummary } from '@components/TireOffer/TireOfferPaymentSummary';
import { Trans } from '@lingui/react/macro';
import { TireQuoteRecordCustomer } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NavioCar, NoddiBasicCard } from 'noddi-ui-web';
import { CustomDateFormats, getCarDisplayName, noddiFormatDate } from 'noddi-util';
import { NavioTireSeasonChip } from 'noddi-web';
import { getCommonTranslations } from '../../utils/commonTranslations';
import { DownloadOrderReceiptButton } from './DownloadOrderReceiptButton';

interface TireOrderDetailsProps {
  tireOffer: TireQuoteRecordCustomer;
}

export const TireOrderDetails = ({ tireOffer }: TireOrderDetailsProps) => {
  const carName = getCarDisplayName({ car: tireOffer.car, showYear: false });

  const selectedQuoteItem = tireOffer.quoteItems.find((item) => item.isSelected);

  if (!selectedQuoteItem) {
    return null;
  }

  const estimatedDeliveryDate = selectedQuoteItem.quoteItemTires[0]?.inventoryOrder?.estimatedDeliveryDate;
  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-4 md:grid md:grid-cols-2'>
        <div>
          <p className='font-semibold'>
            <Trans>Estimated delivery</Trans>
          </p>
          {estimatedDeliveryDate ? (
            <>
              <div className='flex flex-row items-center gap-2'>
                <NoddiIcon name='Calendar' />
                <p>{noddiFormatDate(estimatedDeliveryDate, CustomDateFormats.FULL_DAY_MONTH)}</p>
              </div>
            </>
          ) : (
            <p>
              <Trans>We will notify you when the tires are ordered</Trans>
            </p>
          )}
        </div>
        <div>
          <p className='font-semibold'>
            <Trans>General details</Trans>
          </p>
          <div className='flex flex-col gap-1'>
            <NavioTireSeasonChip season={tireOffer.season.value} translations={getCommonTranslations().seasonBadge} />
            <div className='flex flex-row items-center gap-2'>
              <NavioCar scale={0.4} />
              <p>{carName}</p>
            </div>
          </div>
        </div>
      </div>

      <NoddiBasicCard className='border border-grey/30'>
        <TireOfferPaymentSummary
          quoteItemTires={selectedQuoteItem.quoteItemTires}
          genericItems={tireOffer.genericItems}
          isStaggered={selectedQuoteItem.isStaggered}
        />
      </NoddiBasicCard>
      {tireOffer.order && tireOffer.isPaid && (
        <div className='flex justify-end'>
          <DownloadOrderReceiptButton orderId={tireOffer.order.id} />
        </div>
      )}
    </div>
  );
};
